class VwHastauyari1DTO {
    id: number = 0;
    kimlikId?: number = null;
    muracaatId?: number = null;
    aktif?: string = "E";
    aciklama?: string = "";
    uyariModulId?: number = null;
    uyaritip?: number = null;
    uyaritarih?: string = null;
    uyariloginkod?: string = "";
    uyaripersonelId?: number = null;
    fkBrans?: number = null;
    hastadosyaaktif?: string = "H";
    fkUyaritip?: number = null;
    uyaribaslangictarih?: string = null;
    uyaribitistarih?: string = null;
    tibbiuyari?: string = "H";
    eklemeTarihi?: string = null;
    ekleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    moduladi?: string = "";
    adiSoyadi?: string = "";
    babaAdi?: string = "";
    bransAdi?: string = "";
    personelAdiSoyadi?: string = "";
};
export default VwHastauyari1DTO;